import React, { useEffect, useState, useMemo } from "react";
import AgentSidebar from "../components/AgentSidebar";
import axios from "../../api/axios";

const MONTHS = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December",];


const BusinessActivityTab = () => {
    const [activityData, setActivityData] = useState({
        online: [], offline: [], hotel: [],
    });

    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchBusinessActivity = async () => {
            try {
                setLoading(true);

                const response = await axios.get("/tracking/businessentity-activiy");

                if (response.data.success) {
                    setActivityData({
                        online: response.data.data?.online || [],
                        offline: response.data.data?.offline || [],
                        hotel: response.data.data?.hotel || [],
                    });
                }
            } catch (error) {
                console.error("Business Activity Error:", error);
            } finally {
                setLoading(false);
            }
        };

        fetchBusinessActivity();
    }, []);

    if (loading) {
        return (<div className="text-center py-5">
            <div
                className="spinner-border text-primary"
                role="status"
            />
        </div>);
    }

    const ActivityItem = ({ item }) => {
        return (<div className="activity-item">
            <div>
                <h6 className="mb-1">
                    {item.businessEntityName}
                </h6>

                <div className="text-muted small">
                    {item.productName}
                </div>

                {item.phoneNumber && (<div className="text-muted small mt-1">
                    {item.phoneNumber}
                </div>)}
            </div>

            <div className="text-end">
                <div className="inactive-days">
                    {item.notUsed || "Never Used"}
                </div>

                <small className="text-muted">
                    not used
                </small>
            </div>
        </div>);
    };

    return (<div className="business-activity">
        <style>{`
        .business-activity .summary-card {
          border: 1px solid #e9ecef;
          border-radius: 12px;
          background: #fff;
          padding: 18px;
        }

        .business-activity .summary-title {
          font-size: 13px;
          color: #6c757d;
          margin-bottom: 5px;
        }

        .business-activity .summary-value {
          font-size: 28px;
          font-weight: 700;
          margin: 0;
        }

        .business-activity .activity-box {
          background: #fff;
          border: 1px solid #e9ecef;
          border-radius: 12px;
          overflow: hidden;
        }

        .business-activity .activity-header {
          padding: 15px 18px;
          border-bottom: 1px solid #e9ecef;
        }

        .business-activity .activity-header h6 {
          margin: 0;
          font-weight: 600;
        }

        .business-activity .activity-list {
          max-height: 520px;
          overflow-y: auto;
        }

        .business-activity .activity-item {
          padding: 16px 18px;
          display: flex;
          justify-content: space-between;
          align-items: center;
          gap: 15px;
          border-bottom: 1px solid #f1f3f5;
        }

        .business-activity .activity-item:last-child {
          border-bottom: none;
        }

        .business-activity .activity-item:hover {
          background: #fafafa;
        }

        .business-activity .inactive-days {
          font-weight: 600;
          color: #dc3545;
          white-space: nowrap;
        }

        .business-activity .empty-state {
          padding: 40px 20px;
          text-align: center;
          color: #6c757d;
        }
      `}</style>

        <div className="mb-4">
            <h5 className="mb-1">
                Business Activity
            </h5>

            <p className="text-muted mb-0">
                Businesses inactive for 7 days or more
            </p>
        </div>

        {/* Top Cards */}
        <div className="row g-3 mb-4">
            <div className="col-md-4">
                <div className="summary-card">
                    <div className="summary-title">
                        Inactive Online
                    </div>

                    <p className="summary-value">
                        {activityData.online.length}
                    </p>
                </div>
            </div>

            <div className="col-md-4">
                <div className="summary-card">
                    <div className="summary-title">
                        Inactive Offline
                    </div>

                    <p className="summary-value">
                        {activityData.offline.length}
                    </p>
                </div>
            </div>

            <div className="col-md-4">
                <div className="summary-card">
                    <div className="summary-title">
                        Inactive Hotel
                    </div>

                    <p className="summary-value">
                        {activityData.hotel.length}
                    </p>
                </div>
            </div>
        </div>

        {/* Online + Offline + Hotel Columns */}
        <div className="row g-4">
            {/* Online */}
            <div className="col-lg-4">
                <div className="activity-box">
                    <div className="activity-header">
                        <h6>
                            Online Products
                        </h6>
                    </div>

                    <div className="activity-list">
                        {activityData.online.length > 0 ? (activityData.online.map((item, index) => (<ActivityItem
                            key={`${item.businessEntityId}-${item.productId}-${index}`}
                            item={item}
                        />))) : (<div className="empty-state">
                            No inactive online businesses
                        </div>)}
                    </div>
                </div>
            </div>

            {/* Offline */}
            <div className="col-lg-4">
                <div className="activity-box">
                    <div className="activity-header">
                        <h6>
                            Offline Products
                        </h6>
                    </div>

                    <div className="activity-list">
                        {activityData.offline.length > 0 ? (activityData.offline.map((item, index) => (<ActivityItem
                            key={`${item.businessEntityId}-${item.productId}-${index}`}
                            item={item}
                        />))) : (<div className="empty-state">
                            No inactive offline businesses
                        </div>)}
                    </div>
                </div>
            </div>

            {/* Hotel */}
            <div className="col-lg-4">
                <div className="activity-box">
                    <div className="activity-header">
                        <h6>
                            Hotel Products
                        </h6>
                    </div>

                    <div className="activity-list">
                        {activityData.hotel.length > 0 ? (activityData.hotel.map((item, index) => (<ActivityItem
                            key={`${item.businessEntityId}-${item.productId}-${index}`}
                            item={item}
                        />))) : (<div className="empty-state">
                            No inactive hotel businesses
                        </div>)}
                    </div>
                </div>
            </div>
        </div>
    </div>);
};


const TrackingEventsTab = () => {
    const now = new Date();

    const [selectedYear, setSelectedYear] = useState(now.getFullYear());
    const [selectedMonth, setSelectedMonth] = useState(now.getMonth() + 1);

    const [trackData, setTrackData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState("");

    const years = useMemo(() => {
        const currentYear = new Date().getFullYear();

        return Array.from({ length: 6 }, (_, index) => currentYear - index);
    }, []);

    useEffect(() => {
        const controller = new AbortController();

        const fetchFootFallActivity = async () => {
            try {
                setLoading(true);
                setError("");

                const response = await axios.get("/tracking/foot-fall", {
                    params: {
                        year: selectedYear, month: selectedMonth,
                    }, signal: controller.signal,
                });

                if (!response.data.success) {
                    throw new Error("Failed to fetch traffic data");
                }

                setTrackData(response.data.data);
            } catch (err) {
                if (err.code === "ERR_CANCELED" || err.name === "CanceledError") {
                    return;
                }

                console.error("Footfall fetch error:", err);
                setError("Unable to load traffic information.");
            } finally {
                if (!controller.signal.aborted) {
                    setLoading(false);
                }
            }
        };

        fetchFootFallActivity();

        return () => controller.abort();
    }, [selectedYear, selectedMonth]);

    const {
        today, currentWeek, currentMonth, dailyActivity = [],
    } = trackData || {};

    // Convert API date into YYYY-MM-DD
    const getDateKey = (date) => {
        if (typeof date === "string") {
            const match = date.match(/^\d{4}-\d{2}-\d{2}/);
            if (match) return match[0];
        }

        const parsedDate = new Date(date);

        if (Number.isNaN(parsedDate.getTime())) return "";

        return [parsedDate.getFullYear(), String(parsedDate.getMonth() + 1).padStart(2, "0"), String(parsedDate.getDate()).padStart(2, "0"),].join("-");
    };

    // Map activity by date for fast lookup
    const activityMap = useMemo(() => {
        const map = {};

        dailyActivity.forEach((item) => {
            const key = getDateKey(item.date);

            if (!key) return;

            if (!map[key]) {
                map[key] = {
                    siteVisitCount: 0, productPageVisitCount: 0,
                };
            }

            map[key].siteVisitCount += Number(item.siteVisitCount) || 0;

            map[key].productPageVisitCount += Number(item.productPageVisitCount) || 0;
        });

        return map;
    }, [dailyActivity]);

    // Generate calendar cells
    const calendarDays = useMemo(() => {
        const firstDay = new Date(selectedYear, selectedMonth - 1, 1).getDay();

        const daysInMonth = new Date(selectedYear, selectedMonth, 0).getDate();

        const days = [];

        // Empty cells before first date
        for (let i = 0; i < firstDay; i++) {
            days.push(null);
        }

        for (let day = 1; day <= daysInMonth; day++) {
            const dateKey = [selectedYear, String(selectedMonth).padStart(2, "0"), String(day).padStart(2, "0"),].join("-");

            days.push({
                day, dateKey, activity: activityMap[dateKey] || {
                    siteVisitCount: 0, productPageVisitCount: 0,
                },
            });
        }

        // Fill final calendar week
        while (days.length % 7 !== 0) {
            days.push(null);
        }

        return days;
    }, [selectedYear, selectedMonth, activityMap]);

    const selectedMonthTotal = useMemo(() => {
        return Object.entries(activityMap).reduce((total, [dateKey, item]) => {
            const monthPrefix = [selectedYear, String(selectedMonth).padStart(2, "0"),].join("-");

            if (!dateKey.startsWith(`${monthPrefix}-`)) {
                return total;
            }

            total.site += item.siteVisitCount;
            total.product += item.productPageVisitCount;

            return total;
        }, { site: 0, product: 0 });
    }, [activityMap, selectedYear, selectedMonth]);

    const todayKey = getDateKey(new Date());

    const formatNumber = (value) => Number(value || 0).toLocaleString("en-IN");

    const summaryCards = [{
        title: "Today", data: today, icon: "bi-globe", color: "primary",
    }, {
        title: "Current Week", data: currentWeek, icon: "bi-calendar-week", color: "success",
    }, {
        title: "Current Month", data: currentMonth, icon: "bi-bar-chart", color: "warning",
    },];

    return (<div>
        {/* Summary Cards */}
        <div className="row g-3 mb-4">
            {summaryCards.map((card) => (<div className="col-md-4" key={card.title}>
                <div className="card border-0 shadow-sm h-100">
                    <div className="card-body">
                        <div className="d-flex justify-content-between align-items-start">
                            <div>
                                <p className="text-muted small mb-1">
                                    {card.title}
                                </p>

                                <h4 className="fw-bold mb-2">
                                    {formatNumber(card.data?.siteVisitCount)}
                                </h4>

                                <span className="text-muted small">
                                    Site Visits
                                </span>
                            </div>

                            <div
                                className={`rounded-circle bg-${card.color} bg-opacity-10 d-flex align-items-center justify-content-center`}
                                style={{
                                    width: 45, height: 45,
                                }}
                            >
                                <i
                                    className={`bi ${card.icon} text-${card.color} fs-5`}
                                />
                            </div>
                        </div>

                        <hr />

                        <div className="d-flex justify-content-between">
                            <span className="text-muted small">
                                Product Page Visits
                            </span>

                            <strong>
                                {formatNumber(card.data?.productPageVisitCount)}
                            </strong>
                        </div>
                    </div>
                </div>
            </div>))}
        </div>

        {/* Calendar Card */}
        <div className="card border-0 shadow-sm">
            <div className="card-header bg-white border-bottom py-3">
                <div className="d-flex flex-wrap justify-content-between align-items-center gap-3">
                    <div>
                        <h6 className="fw-semibold mb-1">
                            Daily Traffic Activity
                        </h6>
                        <small className="text-muted">
                            Website traffic by calendar date
                        </small>
                    </div>

                    {/* Year and Month Select */}
                    <div className="d-flex gap-2 flex-wrap">
                        <select
                            className="form-select form-select-sm"
                            style={{ width: 110 }}
                            value={selectedYear}
                            onChange={(e) => setSelectedYear(Number(e.target.value))}
                        >
                            {years.map((year) => (<option key={year} value={year}>
                                {year}
                            </option>))}
                        </select>

                        <select
                            className="form-select form-select-sm"
                            style={{ width: 170 }}
                            value={selectedMonth}
                            onChange={(e) => setSelectedMonth(Number(e.target.value))}
                        >
                            {MONTHS.map((month, index) => (<option key={month} value={index + 1}>
                                ({String(index + 1).padStart(2, "0")}){" "}
                                {month}
                            </option>))}
                        </select>
                    </div>
                </div>
            </div>

            <div className="card-body">
                {/* Month Summary */}
                <div className="d-flex flex-wrap align-items-center gap-4 mb-3">
                    <span className="fw-semibold">
                        {MONTHS[selectedMonth - 1]} {selectedYear}
                    </span>

                    <span className="small text-muted">
                        Site Visits:{" "}
                        <strong className="text-dark">
                            {formatNumber(selectedMonthTotal.site)}
                        </strong>
                    </span>

                    <span className="small text-muted">
                        <i className="bi bi-circle-fill text-success me-2" />
                        Product Visits:{" "}
                        <strong className="text-dark">
                            {formatNumber(selectedMonthTotal.product)}
                        </strong>
                    </span>
                </div>

                {error && (<div className="alert alert-danger py-2">
                    {error}
                </div>)}

                {loading ? (<div className="text-center py-5">
                    <div
                        className="spinner-border text-primary"
                        role="status"
                    />
                    <p className="text-muted mt-2 mb-0">
                        Loading traffic data...
                    </p>
                </div>) : (<div className="overflow-auto">
                    <div style={{ minWidth: 700 }}>
                        {/* Weekdays */}
                        <div
                            className="d-grid text-center bg-light border rounded-top"
                            style={{
                                gridTemplateColumns: "repeat(7, 1fr)",
                            }}
                        >
                            {["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat",].map((day) => (<div
                                key={day}
                                className="py-3 fw-semibold text-muted small"
                            >
                                {day}
                            </div>))}
                        </div>

                        {/* Calendar Grid */}
                        <div
                            className="d-grid border-start"
                            style={{
                                gridTemplateColumns: "repeat(7, 1fr)",
                            }}
                        >
                            {calendarDays.map((item, index) => {
                                if (!item) {
                                    return (<div
                                        key={`empty-${index}`}
                                        className="bg-light border-end border-bottom"
                                        style={{ minHeight: 125 }}
                                    />);
                                }

                                const { siteVisitCount, productPageVisitCount } = item.activity;

                                const isToday = item.dateKey === todayKey;


                                return (<div
                                    key={item.dateKey}
                                    className={`border-end border-bottom p-2 ${isToday ? "bg-primary bg-opacity-10" : ""}`}
                                    style={{ minHeight: 125 }}
                                >
                                    <div className="d-flex justify-content-between align-items-center mb-3">
                                        <span
                                            className={`d-inline-flex align-items-center justify-content-center rounded-circle small ${isToday ? "bg-primary text-white fw-bold" : "fw-semibold"}`}
                                            style={{
                                                width: 28, height: 28,
                                            }}
                                        >
                                            {item.day}
                                        </span>

                                    </div>

                                    <div className="small">
                                        <div
                                            className="d-flex justify-content-between align-items-center gap-1 mb-2">
                                            <span className="text-muted">
                                                Site
                                            </span>
                                            <strong className="text-primary">
                                                {formatNumber(siteVisitCount)}
                                            </strong>
                                        </div>

                                        <div
                                            className="d-flex justify-content-between align-items-center gap-1">
                                            <span className="text-muted">
                                                Product
                                            </span>
                                            <strong className="text-success">
                                                {formatNumber(productPageVisitCount)}
                                            </strong>
                                        </div>
                                    </div>
                                </div>);
                            })}
                        </div>
                    </div>
                </div>)}
            </div>
        </div>
    </div>);
};


const TABS = [{
    id: "tracking-events", label: "Tracking Foot-fall", component: TrackingEventsTab,
}, {
    id: "business-activity", label: "Business Activity", component: BusinessActivityTab,
}];

const TrackingTabs = ({ activeTab, onTabChange }) => {
    return (<ul className="nav nav-tabs mb-4">
        {TABS.map((tab) => (<li className="nav-item" key={tab.id}>
            <button
                type="button"
                className={`nav-link ${activeTab === tab.id ? "active" : ""}`}
                onClick={() => onTabChange(tab.id)}
            >
                {tab.label}
            </button>
        </li>))}
    </ul>);
};

const TabContent = ({ activeTab }) => {
    const selectedTab = TABS.find((tab) => tab.id === activeTab);

    if (!selectedTab) {
        return null;
    }

    const ActiveComponent = selectedTab.component;

    return (<div className="tab-content">
        <div className="tab-pane fade show active">
            <ActiveComponent />
        </div>
    </div>);
};

const AgentTracking = () => {
    const [activeTab, setActiveTab] = useState(TABS[0].id);

    return (<div className="new">
        <AgentSidebar />

        <div className="newContainer flex flex-col h-screen overflow-hidden">
            <div className="container flex-grow overflow-y-auto px-4 py-8">
                <div className="mb-4">
                    <h1 className="text-3xl font-bold mb-2">Tracking</h1>
                </div>

                <TrackingTabs
                    activeTab={activeTab}
                    onTabChange={setActiveTab}
                />

                <TabContent activeTab={activeTab} />
            </div>
        </div>
    </div>);
};

export default AgentTracking;
